import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedUserId = (state: StateSchema): Nullable<string> => state.sendOfferModal.selectedUserId;
